export const DARK_MODE = 'DARK_MODE'
export const LIGHT_MODE = 'LIGHT_MODE'
export const BITS_MODE = 'BITS_MODE'
export const GLASS_MODE = 'BITS_MODE'